import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { DELETE_ROLE_ACTION, deleteRoleUrl, getRoleDetailsUrl, getRoleListUrl, headers, INSERT_UPDATE_ROLE_ACTION, insertUpdateRoleUrl, ROLE_DETAIL_ACTION, ROLE_LIST_ACTION } from "../../utils/constants"

export const get_roleList_action = () => async (dispatch) => {
    try {
        const mapdata = {
            userId: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
        }
        const res = await axiosGet(getRoleListUrl, mapdata, headers);

        dispatch({
            type: ROLE_LIST_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_roleDetails_action = (RoleID) => async (dispatch) => {
    try {
        const mapdata = {
            userId: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            RoleID: RoleID
        }
        const res = await axiosGet(getRoleDetailsUrl, mapdata, headers);
        dispatch({
            type: ROLE_DETAIL_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insertUpdateRole_action = (RoleID, RoleName, ModuleAccessList) => async (dispatch) => {
    console.log(ModuleAccessList, 'before dispatch')
    try {
        const mapdata = {
            userId: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            RoleID: RoleID,
            RoleName: RoleName,
            ModuleAccessList: ModuleAccessList
        }

        console.log("share_credential_action res", mapdata)
        const res = await axiosPost(insertUpdateRoleUrl, mapdata, headers);

        dispatch({
            type: INSERT_UPDATE_ROLE_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
}


export const delete_role_action = (RoleID) => async (dispatch) => {
    try {
        const mapdata = {
            userId: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).UserID ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : null,
            RoleID: RoleID,
        }
        const res = await axiosGet(deleteRoleUrl, mapdata, headers);
        dispatch({
            type: DELETE_ROLE_ACTION,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};